module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "resultContainer"
  }, [_c('v-layout', _vm._b({}, 'v-layout', _vm.layoutAttributes, false), [_c('div', {
    staticClass: "item elevation-5"
  }), _vm._v(" "), _c('div', {
    staticClass: "item elevation-5"
  }), _vm._v(" "), _c('div', {
    staticClass: "item elevation-5"
  })])], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "xs12": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('v-radio-group', {
    model: {
      value: (_vm.alignment),
      callback: function($$v) {
        _vm.alignment = $$v
      },
      expression: "alignment"
    }
  }, _vm._l((_vm.alignmentsAvailable), function(n) {
    return _c('v-radio', {
      key: n,
      attrs: {
        "label": n === '' ? 'Nothing' : n,
        "value": n
      }
    })
  }), 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('v-radio-group', {
    model: {
      value: (_vm.justify),
      callback: function($$v) {
        _vm.justify = $$v
      },
      expression: "justify"
    }
  }, _vm._l((_vm.justifyAvailable), function(n) {
    return _c('v-radio', {
      key: n,
      attrs: {
        "label": n === '' ? 'Nothing' : n,
        "value": n
      }
    })
  }), 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-radio-group', {
    model: {
      value: (_vm.flexDirection),
      callback: function($$v) {
        _vm.flexDirection = $$v
      },
      expression: "flexDirection"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "reverse",
      "hide-details": ""
    },
    model: {
      value: (_vm.reverse),
      callback: function($$v) {
        _vm.reverse = $$v
      },
      expression: "reverse"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "fill-height",
      "hide-details": ""
    },
    model: {
      value: (_vm.fillHeight),
      callback: function($$v) {
        _vm.fillHeight = $$v
      },
      expression: "fillHeight"
    }
  }), _vm._v(" "), _vm._l((_vm.flexDirectionAvailable), function(n) {
    return _c('v-radio', {
      key: n,
      attrs: {
        "label": n === '' ? 'Nothing' : n,
        "value": n
      }
    })
  })], 2)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h5', [_vm._v("Output:")]), _vm._v(" "), _c('code', [_vm._v(_vm._s(_vm.formatAttributes(_vm.layoutAttributes)))])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-df38f512"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/Signin.vue
// module id = 55
// module chunks = 1